import { render } from "./DialogRedemptionConfirmation.vue?vue&type=template&id=4276e78f"
import script from "./DialogRedemptionConfirmation.vue?vue&type=script&lang=js"
export * from "./DialogRedemptionConfirmation.vue?vue&type=script&lang=js"
script.render = render

export default script